module.exports = __webpack_public_path__ + "img/pocket-law.b607a1d3.jpg";